// =====================================================
// 📁 QuotationSummaryEmpty.tsx
// =====================================================

import { FileText } from 'lucide-react';

const QuotationSummaryEmpty = () => {
  return (
    <div
      className="
        flex
        flex-col
        items-center
        justify-center

        rounded-2xl

        border
        border-dashed
        border-slate-200

        bg-slate-50

        px-6
        py-10

        text-center

        dark:border-strokedark
        dark:bg-slate-900
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Icon */}
      {/* ===================================================== */}
      <div
        className="
          flex
          h-20
          w-20

          items-center
          justify-center

          rounded-2xl

          bg-primary/10

          text-primary
        "
      >
        <FileText size={34} />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <h4
        className="
          mt-4

          text-sm
          font-semibold

          text-black

          dark:text-white
        "
      >
        No hay productos agregados
      </h4>

      {/* ===================================================== */}
      {/* 🔹 Description */}
      {/* ===================================================== */}
      <p
        className="
          mt-2

          max-w-[240px]

          text-xs
          leading-relaxed

          text-body
        "
      >
        Los productos seleccionados aparecerán aquí cuando agregues artículos a
        la cotización.
      </p>
    </div>
  );
};

export default QuotationSummaryEmpty;
